export const initialState = {
  creditCard: {
    ownerName: '',
    ownerDocument: '',
    // ownerBirthday: '',
    cardNumber: '',
    cardNumberMasked: '',
    expiration: '',
    security: '',
    coupon: '',
    quantityInstallment: null,
    defaultInstallmentsList: [],
    installmentsList: [],
  }
}

export default function () {
  return initialState
}
